import './index.scss';
import applyCountdown from 'utils/countdown';

export function runFreemiumBlockMessageScript() {
  applyCountdown({
    selector: '.q-freemium-block-message .limit-countdown',
    template: '%H:%M:%S'
  });
}

(function () {
  'use strict';

  runFreemiumBlockMessageScript();
})();
